
import { Icon, InlineIcon } from "@iconify/vue";
import flagIcon from "@iconify-icons/dashicons/flag";
import { defineComponent } from "vue";
import { mapGetters, mapState } from "vuex";
import Toggle from "@/components/Toggle.vue";
import { Environment, VexillaFeatureTypeString } from "@/store/app";
import { VexillaFeatureType } from "@vexilla/client";

export default defineComponent({
  name: "Environment",
  data() {
    return {
      name: null as string | null,
    };
  },
  created() {
    if (!this.environment) {
      this.$router.replace("/");
    } else {
      this.name = this.environment?.name;
    }
  },
  methods: {
    save() {
      this.$store.dispatch("app/editEnvironment", {
        previous: this.environment,
        current: {
          ...this.environment,
          name: this.name,
        },
      });

      this.$router.push(`/environment/${this.name}`);
    },

    randomizeSeed(environment: Environment) {
      const randomValue = Math.floor(Math.random() * 100);
      this.updateDefaultEnvironmentValues(randomValue / 100, "gradual", "seed");
    },

    updateDefaultEnvironmentValues(
      value: boolean | number,
      featureType: VexillaFeatureTypeString,
      propName = "value"
    ) {
      console.log("update value", value);

      this.$store.dispatch("app/updateDefaultEnvironmentValues", {
        environment: this.environment,
        defaultValues: {
          ...this.defaultEnvironmentFeatureValues[this.environment.name],
          [featureType]: {
            ...this.defaultEnvironmentFeatureValues[this.environment.name][
              featureType
            ],
            [propName]: value,
          },
        },
      });
    },
  },
  watch: {
    environment(newEnvironment, oldEnvironment) {
      this.name = newEnvironment?.name;
    },
  },
  computed: {
    ...mapState("app", [
      "hosting",
      "features",
      "defaultEnvironmentFeatureValues",
    ]),
    environment() {
      const environment = this.$store.getters["app/environmentByName"](
        this.$route.params.name
      );
      return environment;
    },
  },
  components: { Toggle },
});
